import { render, staticRenderFns } from "./LanguageChanger.vue?vue&type=template&id=705af424&scoped=true"
import script from "./LanguageChanger.vue?vue&type=script&lang=ts"
export * from "./LanguageChanger.vue?vue&type=script&lang=ts"
import style0 from "./LanguageChanger.vue?vue&type=style&index=0&id=705af424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705af424",
  null
  
)

export default component.exports